import { get_sequential_diff } from "../../lib/misc/array";
import { Maybe } from "../../lib/misc/option";
import { BaseActionWithNav } from "./BaseActionWithNav";
class ResultTable {
    constructor(columns, data) {
        this.columns = columns;
        this.data = data;
    }
    ;
    get strap_index() {
        let idxs = [];
        this.columns.forEach(col => {
            if (0 === col.displayName.localeCompare("strap", "en", { sensitivity: 'base' })) {
                idxs.push(parseInt(col.name));
            }
        });
        return idxs.length > 0 ? idxs[0] : -1;
    }
    get ids() {
        const strap_idx = this.strap_index;
        if (strap_idx === -1)
            return [];
        return this.data.map(row => row[strap_idx]);
    }
    get_data_for(strap) {
        let schema = {};
        for (let col of this.columns.filter((c) => c.visible))
            schema[col.displayName] = null;
        const row = this.data.find((r) => r[this.strap_index] === strap);
        if (!row)
            return schema;
        for (const col of Object.keys(schema)) {
            schema[col] = row[this.columns.findIndex((c) => c.displayName === col)];
        }
        return schema;
    }
}
export class AddParcelsAction extends BaseActionWithNav {
    constructor(layer) {
        super('ADD PARCELS');
        this.layer = layer;
        this.exit_ctx = '';
    }
    validate(message) {
        return super.validate(message) && typeof message.table === 'string' && message.table.length > 0;
    }
    on_valid_message() { }
    async singleton_ctx_handler(focused, ids) {
        this.layer.clear();
        if (ids.length === 0)
            return;
        await this.layer.add_features_by_ids(ids, focused);
    }
    async set_ctx_handler(focused, ids) {
        if (ids.length === 0)
            return;
        let diff = get_sequential_diff(this.layer.features.map(f => f.get(this.layer.identifier)), ids);
        await this.layer.add_features_by_ids(diff.adds, focused);
        this.layer.remove_features_by_ids(diff.subs);
        if (this.layer.ids.includes(focused))
            this.layer.clicked = focused;
    }
    async group_ctx_handler(focused, ids) {
        this.layer.clear();
        if (ids.length === 0)
            return;
        await this.layer.add_features_by_ids(ids, focused);
    }
    async interpret(message) {
        const entry_ctx = this.ctx();
        let resultObj = JSON.parse(message.table);
        let resultTable = new ResultTable(resultObj.columns, resultObj.data);
        let ids = resultTable.ids;
        switch (entry_ctx.map(c => c.name).unwrapOr('')) {
            case 'group':
                this.exit_ctx = '';
                break;
            default:
                this.exit_ctx = 'set';
                break;
        }
        if (ids.length === 0)
            return;
        if (!message.focused && !ids.includes(this.layer.clicked))
            message.focused = ids[0];
        else if (!message.focused)
            message.focused = this.layer.clicked;
        switch (entry_ctx.map(c => c.name).unwrapOr('')) {
            case 'singleton':
                await this.singleton_ctx_handler(message.focused, ids);
                break;
            case 'group':
                await this.group_ctx_handler(message.focused, ids);
                break;
            default:
                await this.set_ctx_handler(message.focused, ids);
                break;
        }
        for (let parcel of this.layer.features) {
            const strap = parcel.get(this.layer.identifier);
            const record = resultTable.get_data_for(strap);
            for (let key in record)
                parcel.set(key, record[key]);
        }
        if (this.layer.colorized) {
            this.layer.colorize_current_parcels();
            this.layer.color_manager.populate_legend();
        }
    }
    reset() {
        this.exit_ctx = '';
    }
    after_valid_message() {
        let ret_val = {
            zoom: true,
            center: false,
            context: this.exit_ctx,
            fail: false,
            navigate: Maybe(this.layer.clicked)
        };
        this.reset();
        return ret_val;
    }
}
